import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  font-size: 25px;\n  padding: 6px;\n  display: inline;\n\n  filter: ', ';\n  opacity: ', ';\n  cursor: ', ';\n'], ['\n  font-size: 25px;\n  padding: 6px;\n  display: inline;\n\n  filter: ', ';\n  opacity: ', ';\n  cursor: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 15px;\n  height: 15px;\n  font-size: 8px;\n  font-weight: bold;\n  background-color: ', ';\n  color: black;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 30%;\n  position: absolute;\n  right: 0px;\n  top: 0px;\n'], ['\n  width: 15px;\n  height: 15px;\n  font-size: 8px;\n  font-weight: bold;\n  background-color: ', ';\n  color: black;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 30%;\n  position: absolute;\n  right: 0px;\n  top: 0px;\n']);

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Tooltip } from '../../../..';
import { styles, utils } from 'gipsy-misc';

var ReactionSign = function (_PureComponent) {
  _inherits(ReactionSign, _PureComponent);

  function ReactionSign() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReactionSign);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactionSign.__proto__ || Object.getPrototypeOf(ReactionSign)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function () {
      var _this$props = _this.props,
          hasReaction = _this$props.hasReaction,
          active = _this$props.active,
          sign = _this$props.sign,
          reactions = _this$props.reactions;

      var data = void 0;
      if (hasReaction && active && reactions.length > 0) {
        data = { paramName: 'reactions', value: reactions[0], method: 'remove' };
      }
      if (!hasReaction || !active) {
        data = { paramName: 'reactions', value: { reaction: sign }, method: 'add' };
      }
      return _this.props.onClick(data);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReactionSign, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          sign = _props.sign,
          reactions = _props.reactions,
          active = _props.active,
          isAssignee = _props.isAssignee;

      var tooltipText = utils.reactions.makeTooltipText(reactions);
      return React.createElement(
        ReactionSignContainer,
        { active: active, clickable: !isAssignee, onClick: this.onClick, onChange: this.onChange },
        sign,
        isAssignee && reactions.length > 0 && React.createElement(
          Badge,
          null,
          reactions.length
        ),
        React.createElement(Tooltip, { text: tooltipText, vs: 50, hs: 18, position: 'bottom left' })
      );
    }
  }]);

  return ReactionSign;
}(PureComponent);

ReactionSign.propTypes = {
  sign: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  reactions: PropTypes.array,
  isAssignee: PropTypes.bool
};


var ReactionSignContainer = styled.div(_templateObject, function (props) {
  return props.active ? 'grayscale(0%)' : 'grayscale(100%)';
}, function (props) {
  return props.active ? 1 : 0.5;
}, function (props) {
  return props.clickable ? 'pointer' : '';
});

var Badge = styled.div(_templateObject2, styles.colors.buttonDarkColor);

export { ReactionSign };
//# sourceMappingURL=ReactionSign.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/components/Header/ReactionHeader/ReactionSign.js
// module id = 1094
// module chunks = 0